import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { filterBy } from '@ember/object/computed';
import Controller from '@ember/controller';

export default class IndexController extends Controller {
  queryParams = ['continuation', 'expand'];

  @tracked continuation = null;
  @tracked expand = null;
  @tracked expanded = [];

  @filterBy('model', 'visible') backfills;

  @action
  expandAction(id) {
    this.expanded = [...this.expanded, id];
  }

  @action
  collapseAction(id) {
    this.expanded = this.expanded.filter((e) => e !== id);
  }
}
